import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignerItemSpacer,
  ReportDesignItemConfig
} from "../../report-design-item";

@Pipe({
  name: "asSpacerConfig",
  standalone: false
})
export class ReportItemConfigAsSpacerPipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignerItemSpacer {
    return <ReportDesignerItemSpacer>value;
  }
}
